export class TipoTarjeta{
    public constructor(
        public id: String = "",
        public nombre :String = "",
        public usuario_id:String = null
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/tipo-tarjeta.ts